import {
    AfterViewInit,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    ElementRef,
    HostListener,
    Inject,
    inject,
    OnInit,
    PLATFORM_ID,
    ViewChild,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

import { Subscription } from 'rxjs';

import { CoreComponentsModule } from '../core-components.module';
import { NavigationService } from '../navigation/navigation.service';
import { WINDOW } from '@src/app/shared/models/tokens';
import { ScriptLoaderService } from '@src/app/shared/services/script-loader.service';

@Component({
    selector: 'vision2-wrapped-layout',
    templateUrl: './wrapped-layout.component.html',
    styleUrls: ['./wrapped-layout.component.scss'],
    imports: [CoreComponentsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WrappedLayoutComponent implements OnInit, AfterViewInit {
    @ViewChild('topContent') topContent: ElementRef;

    // Add scroll behavior properties
    lastScrollTop: number = 0;
    scrollingUp: boolean = true;
    scrollThreshold: number = 10;
    navPanelSubscription: Subscription;
    isNavPanelShown: boolean;

    navService = inject(NavigationService);

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(WINDOW) private window: Window,
        @Inject(DOCUMENT) private document: Document,
        private scriptLoader: ScriptLoaderService,
    ) {
        this.scriptLoader.init();
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (isPlatformBrowser(this.platformId)) {
            const currentScrollTop =
                this.window.pageYOffset ||
                this.document.documentElement.scrollTop;

            // Determine scroll direction
            if (
                currentScrollTop > this.lastScrollTop &&
                currentScrollTop > this.scrollThreshold
            ) {
                // Scrolling down and past threshold
                this.scrollingUp = false;
            } else {
                // Scrolling up or at the top
                this.scrollingUp = true;
            }

            this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        }
    }

    ngAfterViewInit(): void {
        this.topContent.nativeElement.style.minHeight = '90vh';
    }

    ngOnInit() {
        this.navPanelSubscription = this.navService.navPanelState$.subscribe(
            (isShown) => {
                if (isShown) {
                    this.isNavPanelShown = true;
                } else {
                    this.isNavPanelShown = false;
                }
            },
        );
    }
}
